import { UIHeading4 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from '../styles.css';

interface IDemandTrapProps {
  text: string;
  onClick(): void;
}

export function DemandTrap({ text, onClick }: IDemandTrapProps) {
  return (
    <div className={styles['action_button']} onClick={onClick} data-testid="demand-trap">
      <UIHeading4 color="primary_100">{text}</UIHeading4>
    </div>
  );
}
